// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"708d357c","407":"5ef79917","680":"23f2c1e2","787":"750ef74d","866":"e6147771"}[chunkId] + ".chunk.js";
};